import React from 'react'
import ModalFormUI from '../../../widgets/form/ModalFormUI'
import InputTextSF from '../../../widgets/form/InputTextSF'
import InputSelectUI from '../../../widgets/form/InputSelectUI'

const MappingUpdateModalUI = ({ context, successMsg, errorList, setErrorList,
  // sourceValue
  sourceValue, onSourceValueChange, sourceValueError, setSourceValueError,
  // superuser role
  mappedValue, mappedValueList, onMappedValueChange, mappedValueError,
  //
  ignoreSpaces, onIgnoreSpacesChange, booleanList,
  // modes
  updateMode, submitted,
  // event handlers
  onSubmit, onCancelClick,
}) =>
  <ModalFormUI
    context={context}
    titleLabel='Update keywords'
    buttonLabel='Update'
    cancelLabel='Cancel'
    isOpen={updateMode}
    onRequestClose={onCancelClick}
    successMsg={successMsg}
    errorList={errorList}
    setErrorList={setErrorList}
    onSubmit={onSubmit}
    busy={submitted}
  >
    <InputTextSF type='text' name='sourceValue' label='Keywords' maxLength={100}
      value={sourceValue} onChange={onSourceValueChange}
      error={sourceValueError} setError={setSourceValueError}
      autoFocus={true} help='Remove keywords to delete this entry'
    />
    <InputSelectUI name='mappedValue' label='Category' value={mappedValue}
      optionList={mappedValueList}
      onChange={onMappedValueChange} error={mappedValueError}
    />
    <InputSelectUI name='ignoreSpaces' label='Ignore spaces'
      value={ignoreSpaces} optionList={booleanList}
      onChange={onIgnoreSpacesChange}
    />
  </ModalFormUI>

export default MappingUpdateModalUI
